import React, {} from 'react';
import {connect} from "react-redux";
import QuotesSwitcher from "./quotesSwitcher/quotesSwitcher";
import ModeDropdown from "./ModeDropdown";
import {isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";

const SqftHeader = (props) => {
  const {roomSwitcher, isMobile} = props
  const isCabinetsMode = isSFTCabinetsGroup();

  return (
    <div className="header-bar">
      { roomSwitcher.isVisible && !isMobile ? <QuotesSwitcher type={1}/> : null }
      {/*<QuotesSwitcher type={1}/>*/}
      { isCabinetsMode ? <ModeDropdown/> : null }
    </div>
  )
};

const mapStateToProps = (store) => ({
  roomSwitcher: store.sqftMenuState.roomSwitcher,
  isMobile: store.serverState.isMobile,
});

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftHeader);
